<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" style="width: 500px;" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row)">修改</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="details(row.id)">详情</Button>
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10
				},
				deleteId: '',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '订单金额',
						key: 'money',
						render: (h, params) => {
							return h("div", params.row.money / 100)
						}
					},
					{
						title: '是否已支付',
						key: 'isPay',
						render: (h, params) => {
							if (params.row.isPay == true) {
								return h("div", "已支付")
							} else {
								return h("div", "未支付")
							}

						}
					},
					{
						title: '支付方式',
						key: 'payWay',
						render: (h, params) => {
							switch (params.row.payWay) {
								case "1":
									return h("div", "现金")
									break;
								case "2":
									return h("div", "支付宝")
									break;
								case "3":
									return h("div", "微信")
									break;
								case "4":
									return h("div", "银行卡支付")
									break;
								case "99":
									return h("div", "未支付")
									break;
								default:
									return h("div", "错误")
									break;
							}

						}
					},
					{
						title: '广告投放商',
						key: 'advSponsor',
						render: (h, params) => {
							return h("div", params.row.advSponsor.companyName)
						}
					},
					{
						title: '录入人',
						key: 'advEmp',
						render: (h, params) => {
							return h("div", params.row.advEmp.name)
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '支付有效时间',
						key: 'validDate'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(row) { //修改
			    if(row.isPay){
					this.$Message.error('订单已支付，不能进行修改!');
					return ;
				}
				this.$router.push({
					name: 'adv/order/update',
					query: {
						id: row.id
					}
				})
			},
			details(id) { //详情
				
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			add() {
				this.$router.push({
					name: 'adv/order/add'
				})
			},
			updteState() {
				if (this.deleteId == "") {
					this.$Message.error('参数错误，请刷新页面后重试!');
				} else {
					this.$http.post(http.url+'/adv/emp/update/state', {
						id: this.deleteId
					}).then(res => {
						let data = res.data
						switch (data.code) {
							case 200:
								this.modal_loading = false;
								this.modal2 = false;
								this.$Message.success('修改成功！！！');
								this.ajaxPage()
								break;

							case 1000:
								this.$Message.error('登陆失效，请重新登陆!');
								setTimeout(function() {
									this.$router.push('/login')
								}, 1000);
								break;
							case 100:
								this.$Message.error('服务器异常!');
								break;
							case 101:
								this.$Message.error(data.error);
								break;
							default:
								this.$Message.error('服务器异常!');
								break;
						}

					}, res => {
						this.$Message.error('系统异常请刷新后重试!');
					})
				}
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				this.$http.post(http.url+'/adv/order/page', this.query).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							console.log(data)
							this.total = data.page.totalElements
							this.data6 = data.page.content

							this.loading = false
							break;

						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}

				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/order/list.vue